<template>
    <div id="example">
        <div class="container">
            <div id="bar">
                <h1>{{ $t("mail.emailEditor") }}</h1>
                <button v-on:click="saveDesign">{{ $t("message.save") }}</button>
            </div>
            <EmailEditor ref="emailEditor" v-on:load="editorLoaded" v-on:ready="editorReady" />
        </div>
        <a-modal
            v-model="isVisibleAddTemplateName"
            class="testModal2"
            title="Template İsmi"
            centered
            @cancel="() => (isVisibleAddTemplateName = false)"
            @ok="addName"
        >
            <div>
                <input v-model="templateName" placeholder="template isimi..." class="template-name" />
            </div>
        </a-modal>
    </div>
</template>

<script>
import EmailEditor from "../components/EmailEditor.vue";
import sample from "../data/sample.json";
import { mapActions, mapMutations, mapState } from "vuex";
import { MAIL_API } from "../../../../api/mail";

export default {
    name: "exampleView",
    components: {
        EmailEditor,
    },
    props: {
        userId: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            design: {},
            templateName: "",
            subject: "",
            category: "",
            isVisibleAddTemplateName: false,
        };
    },
    ...mapState({
        exportContent: (state) => state.mail.exportContent,
        exportDesign: (state) => state.mail.exportDesign,
    }),
    methods: {
        ...mapMutations({
            CHANGE_EXPORT_CONTENT: "mail/CHANGE_EXPORT_CONTENT",
            CHANGE_EXPORT_DESIGN: "mail/CHANGE_EXPORT_DESIGN",
        }),
        ...mapActions({}),
        addName() {
            this.$refs.emailEditor.editor.exportHtml(async (data) => {
                this.$message.success("Tasarım keydedildi!", 3);

                await MAIL_API.TEMPLATE.createMailTemplate({
                    userId: this.userId,
                    name: this.templateName,
                    subject: this.subject,
                    html: data.html,
                    design: data.design,
                    category: "private",
                }).then(() => {
                    this.templateName = "";
                    this.isVisibleAddTemplateName = false;
                });
            });
        },
        editorLoaded() {
            console.log("editorLoaded", { exportDesign: this.design });
            this.$refs.emailEditor.editor.loadDesign(sample);
        },
        editorReady() {
            console.log("editorReady");
        },
        saveDesign() {
            this.isVisibleAddTemplateName = true;
        },
    },
};
</script>

<style>
html,
body {
    margin: 0;
    padding: 0;
    height: 100%;
    font-family: Arial, "Helvetica Neue", Helvetica, sans-serif;
}

#app,
#example {
    height: 100%;
    display: contents;

    .template-name {
        border-radius: 8px;
        border: 0.1px solid grey;
        padding: 10px;
    }
}

#example .container {
    display: flex;
    flex-direction: column;
    position: relative;
    height: 100%;
}

#bar {
    flex: 1;
    background-color: #40b883;
    color: #fff;
    padding: 10px;
    display: flex;
    max-height: 40px;
    align-items: center;
}

#bar h1 {
    flex: 1;
    font-size: 16px;
    text-align: left;
}

#bar button {
    flex: 1;
    padding: 10px;
    margin-left: 10px;
    font-size: 14px;
    font-weight: bold;
    background-color: #000;
    color: #fff;
    border: 0px;
    max-width: 150px;
    cursor: pointer;
}
</style>
